import z from "zod";
import { projectsId } from "../../db_gen";

const baseUploadSchema = z.object({
  filename: z.string().min(1),
  mimeType: z.string().regex(/^image\/(jpeg|jpg|png|webp|gif)$/),
});

export default {
  avatar: {
    getPresigned: baseUploadSchema,
    complete: z.object({
      uploadKey: z.string(),
    }),
  },
  organizationLogo: {
    getPresigned: baseUploadSchema,
    complete: z.object({
      uploadKey: z.string(),
    }),
  },
  projectImage: {
    getPresigned: baseUploadSchema.extend({ projectId: projectsId }),
    complete: z.object({
      projectId: projectsId,
      uploadKey: z.string(),
    }),
    delete: z.object({
      projectId: projectsId,
    }),
  },
};
